import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const securityGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (!localStorage.getItem('Authorization')) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
